export default "__VITE_ASSET__BpktaEsk__"